const convertImageUrl = (url: string, imageSize: string) => {
  if (url?.includes('?v=')) {
    const index = url.indexOf('?v=');
    const newUrl = url.slice(0, index) + imageSize + url.slice(index);
    return newUrl;
  } else {
    return `${url}${imageSize}`;
  }
};

export { convertImageUrl };
